import React from 'react';
import styled from 'styled-components';

// --- Estilos para el Modal de Recordatorio de Importación SENEBI ---

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  background-color: ${props => props.theme.colors.surface};
  padding: 2.5rem;
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 520px;
  text-align: center;
  border: 3px solid #2196F3;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from { 
      transform: translateY(-30px);
      opacity: 0;
    }
    to { 
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const ReminderIcon = styled.div`
  font-size: 3.5rem;
  margin-bottom: 1rem;
  animation: bounce 1.5s ease-in-out infinite;

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-10px); }
    60% { transform: translateY(-5px); }
  }
`;

const ModalTitle = styled.h2`
  font-family: ${props => props.theme.typography.titleFamily};
  color: #2196F3;
  margin: 0 0 1.5rem 0;
  font-size: 1.6rem;
  font-weight: 700;
`;

const ModalText = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  line-height: 1.6;
  margin-bottom: 2rem;
  font-size: 1.1rem;
`;

const TimeInfo = styled.div`
  background-color: #E3F2FD;
  border-left: 4px solid #2196F3;
  padding: 1rem 1.5rem;
  border-radius: 4px;
  margin-bottom: 2rem;
  text-align: left;
`;

const TimeText = styled.p`
  color: #1976D2;
  margin: 0;
  font-weight: 600;
  font-size: 0.95rem;
`;

const HighlightBox = styled.div`
  background-color: #FFF8E1;
  border: 2px solid #FFC107;
  border-radius: 8px;
  padding: 1.2rem;
  margin-bottom: 2rem;
`;

const HighlightText = styled.p`
  color: #F57C00;
  margin: 0;
  font-weight: 700;
  font-size: 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const ActionButton = styled.button`
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 1rem;
  padding: 1rem 2rem;
  border-radius: ${props => props.theme.borderRadius};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ImportButton = styled(ActionButton)`
  background-color: #4CAF50;
  color: white;
  
  &:hover:not(:disabled) {
    background-color: #45a049;
    transform: translateY(-2px);
  }
`;

const LaterButton = styled(ActionButton)`
  background-color: transparent;
  color: ${props => props.theme.colors.textSecondary};
  border: 2px solid ${props => props.theme.colors.border};
  
  &:hover:not(:disabled) {
    background-color: ${props => props.theme.colors.border};
  }
`;

const ImportSenebiReminderModal = ({ isOpen, onGoToImport, onDismiss, currentTime }) => {
  if (!isOpen) return null;

  const formatTime = (date) => {
    return date.toLocaleTimeString('es-AR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  return (
    <ModalBackdrop onClick={onDismiss}>
      <ModalContent className="axon-modal-sheet" onClick={(e) => e.stopPropagation()}>
        <ReminderIcon>📄</ReminderIcon>
        
        <ModalTitle>¡Recordatorio SENEBI!</ModalTitle>
        
        <ModalText>
          Son las <strong>{formatTime(currentTime)}</strong> y es hora de cargar las operaciones 
          de SENEBI del día.
        </ModalText>

        <HighlightBox>
          <HighlightText>
            🔔 No olvides importar el archivo CSV con las operaciones del día
          </HighlightText>
        </HighlightBox>

        <TimeInfo>
          <TimeText>
            ⏰ Horario: 17:30 hs - Recordatorio diario para Traders
          </TimeText>
          <TimeText>
            📊 Acción: Cargar archivo CSV de operaciones SENEBI
          </TimeText>
          <TimeText>
            💡 Tip: Verifica que todas las columnas se importen correctamente
          </TimeText>
        </TimeInfo>

        <ModalText>
          ¿Quieres ir a la sección de importación ahora?
        </ModalText>
        
        <ButtonContainer className="axon-modal-actions">
          <ImportButton onClick={onGoToImport}>
            📥 Ir a Importar CSV
          </ImportButton>
          
          <LaterButton onClick={onDismiss}>
            ⏰ Recordar más tarde
          </LaterButton>
        </ButtonContainer>
      </ModalContent>
    </ModalBackdrop>
  );
};

export default ImportSenebiReminderModal;